import { createGlobalStyle } from 'styled-components';

// Polyfill :focus-visible
import 'focus-visible';

const GlobalStyle = createGlobalStyle`
  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
  }

  div.sentry-error-embed-wrapper {
    z-index: ${({ theme }) => theme.zIndices.modal};
  }
`;

export default GlobalStyle;
